export function clearUrlPath(path) {
    return (path.split('#')[0] || '').split('?')[0] || '';
}
